<template>
  <div class="all-skill-page">
    <div class="edit-wrap" v-if="userInfo">
      <h3 class="skill-title">
        常用技能
        <p style="flex: 1">點擊編輯添加您的常用技能</p>
        <button class="btn-edit" v-if="!isEdit" @click="isEdit = true">
          <span>编辑</span>
        </button>
        <button class="btn-edit" v-else @click="handleSubmit">
          <span>完成</span>
        </button>
      </h3>
      <div class="my-skill-list">
        <div
          class="my-skill-box"
          v-for="(item, index) in dialogGames"
          :key="index + 'n'"
          @click="mySkillHandle(item)"
        >
          <span>{{ item.name }}</span>
          <i
            class="skill-remove-icon el-icon-minus"
            v-if="isEdit"
            @click="changeActive(item)"
          ></i>
        </div>
      </div>
    </div>
    <div class="game-list-wrap">
      <ul class="category-nav">
        <li
          :class="{ active: categoryIdx == index }"
          v-for="(category, index) in rels"
          :key="index"
          @click="scrollToCategory(index)"
        >
          {{ category[1] }}
        </li>
      </ul>
      <div class="game-list-scroll">
        <div v-for="(list, index) in lists" :key="index" class="game-wrap">
          <div class="title">{{ rels[index][1] }}</div>
          <ul class="game-list">
            <li
              v-for="item in list"
              :key="item.id"
              class="game-item"
              :class="{ active: myGamesId.includes(item.id) && isEdit }"
              @click="changeActive(item)"
            >
              <div class="img">
                <img :src="item.imageUrl + '?d=300x300'" />
                <i
                  v-if="isEdit"
                  :class="
                    myGamesId.includes(item.id)
                      ? 'skill-remove-icon el-icon-minus'
                      : 'skill-add-icon el-icon-plus'
                  "
                ></i>
              </div>
              <div class="name">
                <p>{{ item.name }}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      isMobile: window.innerWidth < 600,
      lists: [],
      rels: [['HOT', '熱門推薦'], ['PHONE', '手機遊戲'], ['PC', '電腦遊戲'], ['CONSOLE', '主機遊戲'], ['VOICE', '語音陪伴'], ['OTHER', '更多技能']],
      categoryIdx: 0,
      dialogGames: [],
      myGamesId: [],
      isEdit: false // 是否是編輯常用技能中
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'allGames', 'myGames', 'allGameCustomList']),
  },
  async created() {
    if (this.allGameCustomList.length == 0) {
      await this.$store.dispatch('app/getGamesList');
    }
    this.dialogGames = [...this.myGames];
    this.myGamesId = this.myGames.map(item => item.id);
    this.initLists();
  },
  methods: {
    scrollToCategory(idx) {
      let parentOffsetTop = document.querySelector('.game-list-scroll').offsetTop;
      let _gameWrap = document.querySelectorAll('.game-wrap')[idx];
      document.querySelector('.game-list-scroll').scrollTo(0, _gameWrap.offsetTop - parentOffsetTop);
      this.categoryIdx = idx;
    },
    initLists() {
      const { rels } = this
      for (let i = 0; i < rels.length; i++) {
        if (i == 0) {
          this.lists.push(this.allGameCustomList.slice(0, 12));
          continue;
        }
        const list = this.allGames[rels[i][0]]
        if (list && list.length) {
          this.lists.push(list)
        }
      }
    },
    changeActive(item) {
      if (!this.isEdit) {
        this.goPlayerList(item)
        return
      }
      const index = this.myGamesId.indexOf(item.id);
      if (index === -1) {
        // 添加
        if (this.myGamesId.length > 9) {
          this.$message.warning('最多允許設置10個常用技能喔');
          return;
        }
        this.myGamesId.push(item.id);
        this.dialogGames.push(item)
      } else {
        // 移除
        this.myGamesId.splice(index, 1);
        this.dialogGames.splice(index, 1);
      }
    },
    mySkillHandle(item) {
      if (!this.isEdit) this.goPlayerList(item)
    },
    goPlayerList(item) {
      this.$router.push({ path: '/player-list/' + item.id })
      this.$emit('close', false)
    },
    handleSubmit() {
      const loading = this.$loading({
        lock: true,
        text: '保存中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$http
        .post('/game/userCustom/save', {
          gameIds: this.myGamesId
        })
        .then(({ code }) => {
          if (code == 200) {
            this.$store.dispatch('app/getGamesList').then(() => {
              this.isEdit = false;
              loading.close();
            });
          } else {
            loading.close();
          }
        });
    }
  },
}
</script>

<style lang="scss" scoped>
.all-skill-page {
  @include flex(flex-start, stretch, column);
  width: 895px;
  max-height: 80vh;
  .edit-wrap {
    background: #fff;
    border-radius: 4px;
    padding: 24px;
    margin-top: 24px;
    h3 {
      line-height: 28px;
      color: $color-gray-1;
      font-size: 20px;
      font-weight: 600;
      @include flex(flex-start, center);
    }
    p {
      line-height: 28px;
      color: $color-gray-3;
      font-size: 14px;
      font-weight: normal;
      display: inline-block;
      margin-left: 8px;
    }
  }
  .game-list-wrap {
    margin-top: 24px;
    padding: 24px 24px;
    background: #fff;
    margin-bottom: 38px;
    border-radius: 4px;
    min-height: 100%;
    @include flex(flex-start, stretch, column);

    .game-list-scroll {
      overflow-y: auto;
      overflow-x: hidden;
      margin-right: -20px;
      height: 100%;
    }
    .category-nav {
      width: 100%;
      @include flex(flex-start);
      margin-bottom: 48px;
      margin-left: -24px;
      li {
        width: 128px;
        font-size: 20px;
        line-height: 28px;
        color: #636d86;
        position: relative;
        cursor: pointer;
        @include flex;
        &.active {
          font-weight: 600;
          color: #222c43;
        }
        &.active::after {
          content: '';
          display: block;
          width: 48px;
          height: 6px;
          left: 50%;
          bottom: -7px;
          position: absolute;
          background: #fed838;
          border-radius: 4px;
          flex: none;
          order: 1;
          flex-grow: 0;
          margin-left: -24px;
        }
      }
    }
  }
  .game-wrap {
    .title {
      padding: 8px 0;
      font-weight: 600;
      font-size: 20px;
      line-height: 28px;
      display: flex;
      align-items: center;
      color: #636d86;
      margin-bottom: 10px;
    }
    .game-list {
      @include flex(flex-start);
      flex-wrap: wrap;
      margin: 0 -13px;
    }
    .game-item {
      @include flex(flex-start, stretch, column);
      position: relative;
      margin: 0 15px 12px;
      width: 88px;
      height: 140px;
      // border-radius: 6px;
      cursor: pointer;
      text-align: center;
      .img {
        position: relative;
        overflow: hidden;
        width: 100%;
        height: 0;
        padding-top: 100%;
        border-radius: 6px;
        img {
          position: absolute;
          left: 50%;
          top: 50%;
          width: 100%;
          height: auto;
          transform: translate(-50%, -50%);
          transition: transform 0.2s;
        }
      }
      .name {
        padding: 8px 0;
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
        // display: flex;
        align-items: center;
        text-align: center;
        color: #222c43;
      }
      &:hover {
        .img img {
          transform: translate(-50%, -50%) scale(1.14);
        }
      }
      &.active {
        background: #fab93c;
        .name {
          color: #fff;
        }
        &::after {
          box-sizing: content-box;
          content: '';
          position: absolute;
          z-index: 1;
          left: -2px;
          top: -2px;
          width: 100%;
          height: 100%;
          border: 2px solid #fab93c;
          border-radius: 6px;
        }
      }
    }
  }
}
.skill-title {
  line-height: 28px;
  font-size: 20px;
  font-weight: 600;
  color: #222c43;
}
.my-skill-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-top: 12px;
}
.my-skill-box {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  // width: 96px;
  padding: 4px 16px;
  height: 32px;
  margin: 0 8px 8px 0;
  border-radius: 6px;
  color: #636d86;
  font-size: 14px;
  cursor: pointer;
  border: 1px solid #dddfe6;
  border-radius: 50px;
  &:hover {
    background: #e8eaee;
  }
  .skill-remove-icon{
    right: -5px;
    top: -5px;    
    font-size: 10px;
    border-radius: 50%;
  }
}
.btn-edit {
  background: none;
  color: #007aff;
  font-size: 15px;
}
.skill-remove-icon,
.skill-add-icon {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 16px;
  height: 16px;
  right: 0;
  top: 0;
  border-radius: 0 6px 0 6px;
  font-size: 12px;
  font-weight: 700;
  color: #ffffff;
}
.skill-remove-icon {
  background: #636d86;
}
.skill-add-icon {
  background: #007aff;
}

@media screen and (max-width: 599px) {
  .all-skill-page {
    width: 100%;
    height: 80vh;
    margin-top: 20vh !important;
    .game-wrap {
      .game-item {
        width: calc(33.3% - 8px);
      }
    }
  }
}
</style>
